import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { Draft } from "../lib/api";

interface Vars {
  draftId: string;
  candidateId: string | null;
}

export const useSelectImage = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ draftId, candidateId }: Vars) => api.images.select(draftId, candidateId),
    onMutate: async ({ draftId, candidateId }) => {
      await qc.cancelQueries({ queryKey: ["draft", draftId] });
      const prev = qc.getQueryData<Draft>(["draft", draftId]);
      if (prev) {
        qc.setQueryData<Draft>(["draft", draftId], { ...prev, selectedImageId: candidateId ?? undefined });
      }
      return { prev };
    },
    onError: (_err, { draftId }, ctx) => {
      if (ctx?.prev) qc.setQueryData(["draft", draftId], ctx.prev);
    },
    onSettled: (_data, _err, { draftId }) => {
      qc.invalidateQueries({ queryKey: ["draft", draftId] });
    },
  });
};
